import { useQuery } from '@tanstack/vue-query';
import { useExperienceApi } from '@/shared/api/useExperienceApi';
import { type MaybeRefOrGetter, unref, computed } from 'vue';

export const useCityTours = (citySlug: MaybeRefOrGetter<string | undefined>) => {
  const { getCitiesRegion } = useExperienceApi();

  const { data: cityTours } = useQuery({
    queryKey: ['cityTours', citySlug],
    queryFn: async () => {
      const currentCitySlug = unref(citySlug);

      const response = await getCitiesRegion({
        path: { citySlug: currentCitySlug as string },
      });

      return response.data;
    },
    enabled: computed(() => !!unref(citySlug)),
    retry: false,
  });

  return {
    cityTours: computed(() => cityTours.value),
  };
};
